export const Routes = {
  SupportRoot: 'support',
  ServiceRequests: 'servicerequests',
  ServiceHealth: 'service-health-status',
  ServiceHealthAdmin: 'service-health-status/admin',
  CaseReviews: 'casereviews',
  SupportV2: 'v2',
  Activity: 'activity',
  Details: 'details',
  Create: 'create',
  SEOPSMetadataAdmin: 'support-metadata',
};

export const RoutesV1 = {
  SupportV2: 'v2',
  PublicServiceHealth: 'service-health-status',
  OldPublicServiceHealth: 'csp/service-health-status',
};

export const VirtualDirectory = {
  SupportServiceRequests: 'dashboard/support',
  InternalTools: 'internal/tools',
  SupportVNext: 'dashboard/v2/support',
  CustomerVNext: 'dashboard/v2/customers',
  InternalMetadataAdmin: 'dashboard/v2/internal/support-metadata-admin'
};

export const ComponentId = {
  Overview: 'overview',
  ServiceHealth: 'service-health',
  ServiceHealthAdmin: 'service-health-admin',
  Details: 'details',
  Activity: 'activity',
  CustomerServiceRequest: 'customer-service-request',
};

export const QueryParamsId = {
  TicketId: 'tid',
  CustomerName: 'customerName',
};
